import { render } from "./VTaskCardInline.vue?vue&type=template&id=5fb519c8&ts=true"
import script from "./VTaskCardInline.vue?vue&type=script&lang=ts"
export * from "./VTaskCardInline.vue?vue&type=script&lang=ts"

import "./VTaskCardInline.vue?vue&type=style&index=0&id=5fb519c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__